import request from "../request";
import { get, objToFormData, removeKey, merge } from "../index";
import { set, last } from "lodash";
import { PostXhr } from "../baseRequest";
import BaseUpload from "./baseUpload";

class UploadFileHuawei extends BaseUpload {
  constructor(param) {
    super(param);
    const { policyUrl, headers = {}, url } = param;
    this.policyUrl = policyUrl || url;
    this.policyDict = {};
    this.uploadFileList = [];
    this.headers = merge({ ossType: "HUAWEIOBS " }, headers);
  }

  get uploadFileUrl() {
    const result = get(this.policyDict, "all.data.form-action", "");
    return result;
  }

  formParams = (file) => {
    const fileName = get(file, "name", "");
    const fileType = get(file, "type", "all");
    const policy = { ...get(this.policyDict, "all.data", {}) }; // 先实现不传文件类型的写法
    removeKey(policy, "form-action");
    policy.key += fileName;
    return merge(policy, this.propsFormParams(file, policy));
  };

  /**
   * 根据文件类型不同，取得对应的签名的上传地址
   *
   * @memberof UploadFileHuawei
   */
  uploadFileUrlFormFileType(file) {
    const fileType = get(file, "type", "all");
    const result = get(
      this.policyDict,
      `${fileType}.data.form-action`,
      "找不到"
    );
    return result;
  }

  getSign = async (fileType_) => {
    const fileType = fileType_ || "all";
    if (Object.keys(this.policyDict).includes(fileType)) {
      return this.policyDict[fileType];
    } else {
      const requestData = { url: this.policyUrl, headers: this.headers };
      if (fileType != "all") {
        set(requestData, "param.fileType", fileType);
      }
      const policy = await this.requestPolicy(request, requestData);
      const data = get(policy, "data", {});
      set(data, "form-action", BaseUpload.removeLastSlash(data["form-action"]));
      this.policyDict[fileType] = policy;
      return policy;
    }
  };

  async uploadFile(file) {
    const formObj = this.formParams(file);
    const formData = objToFormData(formObj);
    const fileName = get(formObj, "key", "");
    formData.append("file", file);
    const uploadFileUrl = this.uploadFileUrlFormFileType();
    await PostXhr.new(uploadFileUrl).xhrSend(formData);
    const fileUrl = BaseUpload.removeLastSlash(uploadFileUrl) + "/" + fileName;
    this.uploadFileList.push({ ...file, url: fileUrl });
    return fileUrl;
  }
}

export default UploadFileHuawei;



// WEBPACK FOOTER //
// ./src/yx-widget/utils/upload/uploadFileHuawei.js